<span class="productMapper vetcorPrice">
   <section class="p-2">
      <div
         class="flex-column ml-2"
         style="max-width: 400px; padding-left: 5px; display: inline-block">
         <p-dropdown
            [filter]="true"
            [options]="practices"
            (onChange)="onDropdownSelected($event.value)"
            [ngModel]="selectedPractice()?.id"
            ngModelOptions="{standalone: true}"
            [filterBy]="'searchableText'"
            optionLabel="nameId"
            optionValue="id"
            [placeholder]="placeholderText()"
            [class.hospitalFilterDrop]="true"
            [showClear]="false"></p-dropdown>
      </div>
      <div *ngIf="!selectedPracticeSKey() && !hidePrompt()" style="margin-top: 15px">
         <div class="alert alert-info text-center">Please select a hospital above.</div>
      </div>
   </section>
</span>
